import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import Modal, { ModalHeader } from '../Modal';
import useForm from '../../hooks/useForm';
import Form from '../Form';
import { isEmpty } from '../../utils/lodashExtend';
import systemAlert from '../../utils/systemAlert';
import { changeMasterPassword } from '../../apis/users';
import { setProfile } from '../../store/actions';
import { isFunction } from 'lodash';
import { toast } from '../../utils/toast';

const ChangePassword = ({ open, setOpen }) => {
  const dispatch = useDispatch();
  const { employee } = useSelector(store => ({
    employee: store.Profile.employee
  }), shallowEqual);

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    if (isFunction(setOpen)) setOpen(false);
  };

  const [isForce, setIsForce] = useState(false);

  const [fields] = useState([
    {
      title: "비밀번호",
      type: "password",
      key: "password",
      placeholder: "비밀번호를 입력해주세요"
    },
    {
      title: "비밀번호 확인",
      type: "password",
      key: "pwdCheck",
      placeholder: "비밀번호를 다시 입력해주세요"
    }
  ]);

  const _submit = (form) => {
    systemAlert(`정말 비밀번호를 변경하시겠습니까?`, {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '변경',
          onClick: () => {
            changeMasterPassword(form)
              .then(res => {
                toast.success("비밀번호 변경이 완료되었습니다.");
                isForce ? dispatch(setProfile()) : cancel();
              }).catch((err) =>
                console.error(err)
              );
          }
        },
      ]
    });
  };

  const validate = (_form) => {
    let errors = {};
    const regPwd = /^.*(?=^.{6,12}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&+=]).*$/;
    if (!isEmpty(_form.password)) {
      if (!regPwd.test(_form.password)) {
        errors.password = "영문자, 숫자, 특수문자 조합 6~12자로 설정해주세요";
      }
    }
    if (_form.password !== _form.pwdCheck) {
      errors.pwdCheck = "비밀번호가 동일하지 않습니다.";
    }

    return errors;
  };


  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
  } = useForm(
    {
      password: '',
      pwdCheck: '',
    },
    _submit,
    validate,
  );

  useEffect(() => {
    setIsForce(employee?.isChangePassword);
  }, [employee]);

  return (
    <>
      <Modal isOpen={isForce || open}
        {...(isForce ? {} : { close: cancel })}
        size="md"
      >
        <ModalHeader>마스터계정 비밀번호 변경</ModalHeader>
        <Form
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          submitText={"비밀번호 변경"}
          submit={handleSubmit}
          // isDisabledSubmit={!isEmpty(validate(form))}
          {...(isForce ? {} : { cancel })}
        />
      </Modal>
    </>
  );
};

export default ChangePassword;